import { Controller } from "@hotwired/stimulus"

// Pokazuje mgiełkę (gradient) na dole boxa tylko gdy treść faktycznie wystaje poza box
// i nie jesteśmy na samym dole - czyli gdy ostatni wpis jest przycięty dolną krawędzią.
// Przy krótkiej zawartości (np. jeden wpis) mgiełka jest ukryta. CSS-em tego nie da się
// zrobić dla nakładki nad tekstem, bo trzeba znać scrollHeight elementu.
export default class extends Controller {
  static targets = ["scroll", "fade"]

  connect() {
    this.update = this.update.bind(this)
    this.scrollTarget.addEventListener("scroll", this.update, { passive: true })
    window.addEventListener("resize", this.update)
    // po pierwszym renderze (doładowane obrazki / turbo frames)
    requestAnimationFrame(this.update)
    this.update()
  }

  disconnect() {
    this.scrollTarget.removeEventListener("scroll", this.update)
    window.removeEventListener("resize", this.update)
  }

  update() {
    if (!this.hasFadeTarget || !this.hasScrollTarget) return

    const el = this.scrollTarget
    const moreBelow = el.scrollHeight - el.scrollTop - el.clientHeight > 1
    this.fadeTarget.classList.toggle("hidden", !moreBelow)
  }
}
